module.exports = __webpack_public_path__ + "img/39_3.d49432d8.png";